import { render, staticRenderFns } from "./InputOutputMaterial.vue?vue&type=template&id=139ff793"
import script from "./InputOutputMaterial.vue?vue&type=script&lang=js"
export * from "./InputOutputMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports